export default class EventCard {
    constructor () {
        this.cards = document.querySelectorAll('.card-article-event')

        if (!this.cards)
            return

        this.cards.forEach(card => this.setupEvents(card))
    }

    setupEvents (el) {
        const descriptionWrap = el.querySelector('.card-article-description')
        const readMoreBtn = el.querySelector('.card-article-description-more')

        if (readMoreBtn && descriptionWrap)
            readMoreBtn.addEventListener('click', (e) => {
                e.preventDefault()
                descriptionWrap.classList.add('open')
            })
    }
}
